import type { LADClaimInitialValuesResponse } from './api';

export const normalizeLADClaimInitialValues = (data: LADClaimInitialValuesResponse) => {
  if (!data) {
    return null;
  }
  return {
    currencyCode: data.currencyCode,
    consigneeCountry: data.consigneeCountryCode,
    claimTypeKey: data.claimType,
    claimStatusCode: data.claimStatus,
    reasonCode: data.claimReason,
    reasonType: data.claimReasonType,
    shipperCountry: data.shipperCountryCode,
  };
};
